import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'apiServerUrl',
  pure: true
})
export class ApiServerUrlPipe implements PipeTransform {
  
  transform(path: string): string {
    if (!path) {
      return environment.apiServer || '';
    }
    
    const baseUrl = environment.apiServer || '';
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    
    // Remove trailing slash from baseUrl if present
    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    
    return `${cleanBaseUrl}${cleanPath}`;
  }
}